import React from "react";
import { Outlet } from "react-router-dom";

import AppWrapper from "../../components/cm/AppWrapper";
import SideBarMain from "../../components/cm/SideBarMain";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <Outlet />
    </AppWrapper.WithSidebar>
  );
};
